import { settings } from "../../app/settings";

const ACCESS_TOKEN = settings.accessTokenString ?? "auth";
const REFRESH_TOKEN = settings.refreshTokenString ?? "refresh";
const PERMISSIONS = settings.permissions ?? "permissions";
const PROFILE_SELECTION_PENDING = "profile_selection_pending";
const EMPLOYEE_PROFILES = "employee_profiles";

export const authCallbackPath = "3rd-party/google/auth-callback";
export const selectProfilePath = "select-profile";

export const accessResponseString = settings.accessResponseString ?? "access_id";
export const refreshResponseString = settings.refreshResponseString ?? "refresh_id";
export const refreshSessionString = settings.refreshSessionString ?? "refresh_session_id";

export const userProfileString = settings.userProfileString ?? "userData";
export const userNameString = settings.userNameString ?? "email";
export const passwordString = settings.passwordString ?? "password";
export const reCaptchaString = settings.recaptchaString ?? "recaptcha";

export const passwordChangeRequiredString = settings.passwordChangeRequiredString ?? "IsPasswordChangeRequired";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);

export const getPermissions = () => JSON.parse(localStorage.getItem(PERMISSIONS));

export const getUser = () =>
  localStorage.getItem(userProfileString) ? JSON.parse(localStorage.getItem(userProfileString)) : null;

export const setUser = user => localStorage.setItem(userProfileString, JSON.stringify(user));

export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN);

export const removeUser = () => localStorage.removeItem(userProfileString);

export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};

export const removeTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(PERMISSIONS);
  localStorage.removeItem(PROFILE_SELECTION_PENDING);
  localStorage.removeItem(EMPLOYEE_PROFILES);
};

// Position-based employee profiles: set while the backend session has no roles yet because the employee
// must first pick the node/position to log in as (see SelectProfilePage).
export const setProfileSelectionPending = () => localStorage.setItem(PROFILE_SELECTION_PENDING, "1");

export const clearProfileSelectionPending = () => localStorage.removeItem(PROFILE_SELECTION_PENDING);

export const isProfileSelectionPending = () => localStorage.getItem(PROFILE_SELECTION_PENDING) === "1";

// Cached body of GET account/security/profiles: { enabled, current, profiles }.
export const setEmployeeProfiles = profiles => localStorage.setItem(EMPLOYEE_PROFILES, JSON.stringify(profiles));

export const getEmployeeProfiles = () => {
  try {
    const raw = localStorage.getItem(EMPLOYEE_PROFILES);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Failed to read the cached employee profiles", error);
    return null;
  }
};

export const setPermissions = permissions => localStorage.setItem(PERMISSIONS, permissions);

// Consumes the deep link saved by checkAuth before the user was bounced to /login. Full reload so <Admin> rebuilds
// the resources and menu from the (new) session's permissions.
export const redirectAfterLogin = () => {
  const redirectPath = sessionStorage.getItem("redirectAfterLogin");
  sessionStorage.removeItem("redirectAfterLogin");
  window.location.href = redirectPath && redirectPath !== "/login" ? redirectPath : "/";
};
